module.exports = __webpack_public_path__ + "static/media/recarga_saldo.c0c9e01c.svg";